import React, { useState } from 'react';
import { Popin } from 'Components';

export const KnowMorePopin = () => {
  const [open, setOpen] = useState(false);

  const handleOpenPopin = () => setOpen(true);
  const handleClosePopin = () => setOpen(false);

  return (
    <>
      <span className="underline cursor-pointer text-sm text-navy-blue" onClick={handleOpenPopin}>
        En savoir plus
      </span>

      {open && (
        <Popin onCloseClick={handleClosePopin}>
          <div className="flex flex-col gap-4 text-sm">
            <div>
              <span className="font-bold">Choix «&nbsp;Profil client&nbsp;»</span> : si vous refusez le partage de votre profil client, il
              ne sera pas partagé avec des partenaires pour de la prospection postale et téléphonique ou de la publicité digitale. Par
              exemple, suite à l&apos;achat d&apos;un ordinateur et si je n&apos;ai pas refusé le partage de mon profil client, je vois
              s&apos;afficher ou je reçois une offre de partenaire en rapport avec mon achat d&apos;ordinateur (accessoires,
              imprimantes...).
            </div>

            <a
              href="https://www.darty.com/achat/informations/donnees_personnelles.html"
              target="_blank"
              rel="noreferrer"
              className="underline self-start"
            >
              Plus d&apos;informations dans la politique Données personnelles.
            </a>

            <div>
              <span className="font-bold">Choix «&nbsp;E-mails&nbsp;»</span> : Darty utilise dans ses e-mails des technologies de type «
              pixel » pour contextualiser et améliorer le contenu des e-mails que vous recevez, et recueillir des statistiques sur
              l&apos;ouverture des e-mails et les clics réalisés sur leur contenu.
            </div>
          </div>
        </Popin>
      )}
    </>
  );
};
